export default "__VITE_ASSET__C_AXTG36__"